import React from 'react';
import { ActionIcon, Group, Text } from '@mantine/core';
import { IconArrowLeft } from '@tabler/icons-react';
import { useNavigation } from '@refinedev/core';
import { useCurrentClientIfAvailable } from 'src/clients/context/CurrentClientProvider';

type Props = {
  title: string;
};

export function FormTitle({ title }: Props) {
  const { push } = useNavigation();
  const { client } = useCurrentClientIfAvailable();

  const goToFinancialItems = () => push(`/client/${client?.id}/financial-data`);
  return (
    <Group>
      <ActionIcon variant="subtle" onClick={goToFinancialItems} data-testid="back-button">
        <IconArrowLeft color="black" />
      </ActionIcon>
      <Text size={'displayMd'} fw={600}>
        {title}
      </Text>
    </Group>
  );
}
